var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _vm.eodFieldReviewVisible
    ? _c(
        "div",
        {
          staticClass: "eodFieldReviewTool",
          attrs: { id: "eodFieldReviewTool" },
        },
        [
          _c(
            "div",
            {
              class: {
                "card scroll-Container menu-bg-blue-transparent eod-container":
                  _vm.isEodToolOpen,
              },
              attrs: { id: "eodFieldReviewToolCard" },
            },
            [
              _c("div", { staticClass: "card-body-padding" }, [
                _c("div", { staticClass: "eodFieldReviewTitle" }, [
                  _c("strong", [_vm._v("EOD Field Review")]),
                  _vm._v(" "),
                  _c("div", { staticClass: "eodWindowTools" }, [
                    _c(
                      "span",
                      {
                        staticClass: "resetButton",
                        attrs: { title: "Reset", id: "eodResetButton" },
                        on: { click: _vm.reset },
                      },
                      [
                        _c("fa", {
                          attrs: { icon: ["fas", "redo-alt"], size: "sm" },
                        }),
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _c(
                      "span",
                      {
                        staticClass: "collapseToggle",
                        attrs: {
                          title: _vm.isEodToolOpen ? "Collapse" : "Expand",
                        },
                        on: { click: _vm.toggleEodTool },
                      },
                      [
                        _c("fa", {
                          attrs: {
                            icon: [
                              "fas",
                              _vm.isEodToolOpen ? "caret-up" : "caret-down",
                            ],
                            size: "sm",
                          },
                        }),
                      ],
                      1
                    ),
                  ]),
                ]),
              ]),
              _vm._v(" "),
              _c(
                "div",
                {
                  staticClass: "tab-pane-wrapper",
                  class: {
                    visible: _vm.isEodToolOpen,
                    hidden: !_vm.isEodToolOpen,
                  },
                },
                [
                  _c(
                    "div",
                    { staticClass: "eodFileUploadControl" },
                    [
                      _c(
                        "b-form-group",
                        {
                          staticClass: "form-block",
                          scopedSlots: _vm._u(
                            [
                              {
                                key: "label",
                                fn: function () {
                                  return [_c("strong", [_vm._v("Vehicle *")])]
                                },
                                proxy: true,
                              },
                            ],
                            null,
                            false,
                            174655117
                          ),
                        },
                        [
                          _vm._v(" "),
                          _c(
                            "b-form-select",
                            {
                              class: {
                                "has-value": _vm.selectedVehicle !== null,
                              },
                              scopedSlots: _vm._u(
                                [
                                  {
                                    key: "first",
                                    fn: function () {
                                      return [
                                        _c(
                                          "b-form-select-option",
                                          { attrs: { value: null } },
                                          [
                                            _vm._v(
                                              "\n                Select Vehicle\n              "
                                            ),
                                          ]
                                        ),
                                      ]
                                    },
                                    proxy: true,
                                  },
                                ],
                                null,
                                false,
                                3908727982
                              ),
                              model: {
                                value: _vm.selectedVehicle,
                                callback: function ($$v) {
                                  _vm.selectedVehicle = $$v
                                },
                                expression: "selectedVehicle",
                              },
                            },
                            _vm._l(_vm.vehicles, function (system) {
                              return _c(
                                "option",
                                { key: system.id, domProps: { value: system } },
                                [
                                  _vm._v(
                                    "\n              " +
                                      _vm._s(system.vehicle_name) +
                                      "\n            "
                                  ),
                                ]
                              )
                            }),
                            0
                          ),
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "div",
                        {
                          staticClass: "panel",
                          class: {
                            "is-disabled": _vm.selectedVehicle === null,
                          },
                        },
                        [
                          _c(
                            "div",
                            [
                              !_vm.plannedRouteUploaded
                                ? _c(
                                    "b-form-group",
                                    {
                                      staticClass: "form-block",
                                      scopedSlots: _vm._u(
                                        [
                                          {
                                            key: "label",
                                            fn: function () {
                                              return [
                                                _c("strong", [
                                                  _vm._v("Planned Route File"),
                                                ]),
                                                _vm._v(" "),
                                                _c("img", {
                                                  staticClass:
                                                    "icon ml-1 routeFileIcon",
                                                  attrs: {
                                                    src: require("./../../../assets/routePlanned.svg"),
                                                  },
                                                }),
                                              ]
                                            },
                                            proxy: true,
                                          },
                                        ],
                                        null,
                                        false,
                                        1183672385
                                      ),
                                    },
                                    [
                                      _vm._v(" "),
                                      _c("b-form-file", {
                                        ref: "refPlannedRouteFile",
                                        attrs: {
                                          id: "plannedRouteFile",
                                          accept: ".kml,.kmz",
                                          placeholder:
                                            "Select a Planning file...",
                                          "drop-placeholder":
                                            "Drop file here...",
                                        },
                                        on: {
                                          input: _vm.handlePlannedFileUpload,
                                        },
                                        scopedSlots: _vm._u(
                                          [
                                            {
                                              key: "button-content",
                                              fn: function () {
                                                return [
                                                  _c(
                                                    "span",
                                                    [
                                                      _vm._v(
                                                        "\n                    Browse\n                    "
                                                      ),
                                                      _vm.loadingPlannedRouteFile
                                                        ? _c("b-spinner", {
                                                            staticClass: "mr-2",
                                                            attrs: {
                                                              small: "",
                                                            },
                                                          })
                                                        : _vm._e(),
                                                    ],
                                                    1
                                                  ),
                                                ]
                                              },
                                              proxy: true,
                                            },
                                          ],
                                          null,
                                          false,
                                          1328134077
                                        ),
                                      }),
                                    ],
                                    1
                                  )
                                : _vm._e(),
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c(
                            "div",
                            [
                              !_vm.completedRouteUploaded
                                ? _c(
                                    "b-form-group",
                                    {
                                      staticClass: "form-block",
                                      scopedSlots: _vm._u(
                                        [
                                          {
                                            key: "label",
                                            fn: function () {
                                              return [
                                                _c("strong", [
                                                  _vm._v(
                                                    "Completed Route File"
                                                  ),
                                                ]),
                                                _vm._v(" "),
                                                _c("img", {
                                                  staticClass:
                                                    "icon ml-1 routeFileIcon",
                                                  attrs: {
                                                    src: require("./../../../assets/routeCompleted.svg"),
                                                  },
                                                }),
                                              ]
                                            },
                                            proxy: true,
                                          },
                                        ],
                                        null,
                                        false,
                                        3888707649
                                      ),
                                    },
                                    [
                                      _vm._v(" "),
                                      _c("b-form-file", {
                                        ref: "refCompletedRouteFile",
                                        attrs: {
                                          id: "completedRouteFile",
                                          accept: ".kml,.kmz",
                                          placeholder:
                                            "Select an EOD Trails file...",
                                          "drop-placeholder":
                                            "Drop file here...",
                                        },
                                        on: {
                                          input: _vm.handleCompletedFileUpload,
                                        },
                                        scopedSlots: _vm._u(
                                          [
                                            {
                                              key: "button-content",
                                              fn: function () {
                                                return [
                                                  _c(
                                                    "span",
                                                    [
                                                      _vm._v(
                                                        "\n                    Browse\n                    "
                                                      ),
                                                      _vm.loadingCompletedRouteFile
                                                        ? _c("b-spinner", {
                                                            staticClass: "mr-2",
                                                            attrs: {
                                                              small: "",
                                                            },
                                                          })
                                                        : _vm._e(),
                                                    ],
                                                    1
                                                  ),
                                                ]
                                              },
                                              proxy: true,
                                            },
                                          ],
                                          null,
                                          false,
                                          2505502508
                                        ),
                                      }),
                                    ],
                                    1
                                  )
                                : _vm._e(),
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c(
                            "div",
                            [
                              _c(
                                "b-form-group",
                                {
                                  staticClass: "form-block",
                                  scopedSlots: _vm._u(
                                    [
                                      {
                                        key: "label",
                                        fn: function () {
                                          return [
                                            _c("strong", [_vm._v("Remarks")]),
                                            _vm._v(" "),
                                            _c("fa", {
                                              staticClass: "icon ml-1",
                                              attrs: {
                                                icon: ["fas", "clipboard"],
                                              },
                                            }),
                                          ]
                                        },
                                        proxy: true,
                                      },
                                    ],
                                    null,
                                    false,
                                    1565053055
                                  ),
                                },
                                [
                                  _vm._v(" "),
                                  _c("b-form-textarea", {
                                    ref: "remarks",
                                    staticClass: "contenteditable-element",
                                    attrs: {
                                      id: "remarks",
                                      rows: "6",
                                      cols: "50",
                                    },
                                    on: {
                                      mouseup: function ($event) {
                                        return _vm.enableInput($event)
                                      },
                                      mousedown: function ($event) {
                                        return _vm.enableInput($event)
                                      },
                                    },
                                    model: {
                                      value: _vm.remarksText,
                                      callback: function ($$v) {
                                        _vm.remarksText = $$v
                                      },
                                      expression: "remarksText",
                                    },
                                  }),
                                ],
                                1
                              ),
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _vm.uncoveredEodTrialsFileName
                            ? _c("div", { staticClass: "selectedFileLabel" }, [
                                _c("label", { staticClass: "pt-2" }, [
                                  _vm._v(
                                    "\n              Missed segments ready for download\n              "
                                  ),
                                ]),
                              ])
                            : _vm._e(),
                          _vm._v(" "),
                          _c(
                            "div",
                            [
                              _c(
                                "b-form-group",
                                { staticClass: "form-block" },
                                [
                                  _c(
                                    "div",
                                    { staticClass: "modal-button-row" },
                                    [
                                      _c(
                                        "b-button",
                                        {
                                          staticClass: "downloadFiles-btn",
                                          attrs: {
                                            disabled:
                                              !_vm.isValid ||
                                              (_vm.loadingFile &&
                                                !_vm.plannedRouteFile) ||
                                              (_vm.loadingFile &&
                                                !_vm.completedRouteFile),
                                          },
                                          on: { click: _vm.downloadTextFile },
                                        },
                                        [
                                          _vm.loadingFile
                                            ? _c("b-spinner", {
                                                staticClass: "mr-2",
                                                attrs: { small: "" },
                                              })
                                            : _vm._e(),
                                          _vm._v(
                                            "\n                  Download\n                "
                                          ),
                                        ],
                                        1
                                      ),
                                    ],
                                    1
                                  ),
                                ]
                              ),
                            ],
                            1
                          ),
                        ]
                      ),
                    ],
                    1
                  ),
                ]
              ),
              _vm._v(" "),
              _c("transition", { attrs: { name: "fade" } }, [
                _vm.loadingFile
                  ? _c("div", { staticClass: "eodOverlay" }, [
                      _c("div", { staticClass: "eodSpinner-container" }, [
                        _c("div", { staticClass: "spinner" }),
                        _vm._v(" "),
                        _c("p", { staticClass: "message" }, [
                          _vm._v(_vm._s(_vm.loadingMessage)),
                        ]),
                      ]),
                    ])
                  : _vm._e(),
              ]),
            ],
            1
          ),
        ]
      )
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }